import { render, staticRenderFns } from "./data-board.vue?vue&type=template&id=1472f43a&scoped=true&"
import script from "./data-board.vue?vue&type=script&lang=js&"
export * from "./data-board.vue?vue&type=script&lang=js&"
import style0 from "./data-board.vue?vue&type=style&index=0&id=1472f43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472f43a",
  null
  
)

export default component.exports